import { initReactI18next } from 'react-i18next'
import { LocalFind, LocalInsert } from '@weblite/persist'
import i18next, { TFunction } from 'i18next'
import { translationArabic } from './local-language/arabic/translation'
import { translationPersian } from './local-language/persian/translation'
import { fullReload } from '$func/fullReload'

/**
 * move to separate folder with different namespaces files
 * 🌟 language iso key
 *    📁 translation files and folders
 *      🎦 for every name space
 *      🎦 for evey translation key
 */

const resources = {
  fa: {
    translation: translationPersian,
  },
  ar: {
    translation: translationArabic,
  },
}

i18next.use(initReactI18next).init({
  lng: LocalFind('lang') || 'fa',
  debug: true,
  resources,
})

export const t = i18next.t.bind(i18next) as TFunction | (() => TFunction) | any

export function getCurrentLanguage() {
  return i18next.language || LocalFind('lang') || 'fa'
}

export function changeLanguage(lang: string) {
  i18next.changeLanguage(lang)
  LocalInsert('lang', lang)
  fullReload()
}
